import React, { useState } from 'react';

// material-ui
import {
  Box,
  IconButton,
  Paper,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import moment from "moment";

// icons
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

// store
import { useDeleteSchedule, useScheduleList } from '../../../hooks/useMigration';
import useMigrateStore from '../../../store/useMigrate';
import ConfirmDeleteDialog from '../../../components/alert/alertDialog';

// ==============================|| TRANSITION ||============================== //
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const getSourceName = (row) => {
  const data = row?.task_config?.source?.data;
  return data?.attributes?.name ?? data?.name ?? "-";
};

// ==============================|| MAIN ||============================== //
export default function ScheduleMigrationPage({setSnackbar}) {
  const {
    data: dataSchedule,
    isFetching: isLoadingMigrationSchedule,
    isError: isErrorMigrationSchedule
  } = useScheduleList("MIGRATIONS");
  const { hubname, openProject, setCloseProject, setHubName } = useMigrateStore();
  const { mutate: deleteSchedule, isPending: isDeletingSchedule } = useDeleteSchedule();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedId, setselectedId] = useState(null)
  const [openALertDialog, setopenALertDialog] = useState(false)

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleDeleteSchedule = ({ id }) => {
    setselectedId(id);
    setopenALertDialog(true);
  };

  const handleConfirmDelete = () => {
    const data = dataSchedule?.data.find(res => res.id === selectedId)
    deleteSchedule(selectedId, {
      onSuccess: () => {
        const message = {
          open: true,
          title: `Delete Schedule success`,
          content: `You Successfully delete schedule ${data.schedule_name}`,
          type: 'success'
        };
        setopenALertDialog(false);
        setselectedId(null);
        setTimeout(() => {
          setSnackbar(message);
        }, 500);
      },
      onError: (error) => {
        setSnackbar({
          open: true,
          title: 'Delete data failed',
          content: error?.response?.data?.message || error?.message || 'Something went wrong while pushing data.',
          type: 'error'
        });
      }
    });
  };

  return (
    <Box sx={{width: "100%"}}>
      {/* TABLE */}
      <Paper
          sx={{
            background: '#fff',
            p: 3,
            borderRadius: 2,
            overflow: 'hidden'
          }}
        >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  bgcolor: 'grey.50',
                  '& th': {
                    fontWeight: 'bold',
                    borderBottom: '2px solid',
                    borderColor: 'divider'
                  }
                }}
              >
                <TableCell >Schedule Name</TableCell>
                <TableCell >Source Item Name</TableCell>
                <TableCell >Migration Type</TableCell>
                <TableCell >Time Interval</TableCell>
                <TableCell >Next Execution (UTC)</TableCell>
                <TableCell align="center">
                  Action
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {dataSchedule?.data.map((row) => (
                <TableRow key={row.id} hover>
                  <TableCell>
                    <Typography variant="subtitle2">{row.schedule_name}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2">{getSourceName(row)}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2">{row.migrationType || "Schedule"}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2">{row.frequency}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2">{moment(row.next_run_at).format("YYYY-MM-DD HH:mm:ss")}</Typography>
                  </TableCell>
                 

                  <TableCell align="center">
                    <Tooltip title="Delete Schedule">
                      <IconButton
                        onClick={() => handleDeleteSchedule(row)}
                        sx={{
                          width: 36,
                          height: 36,
                          border: '1px solid',
                          borderColor: 'error.light',
                          color: 'error.main',
                          '&:hover': {
                            bgcolor: 'error.main',
                            color: '#fff'
                          }
                        }}
                      >
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
            component="div"
            count={dataSchedule?.totalRows || 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
      </Paper>
      <ConfirmDeleteDialog
          open={openALertDialog}
          loading={isDeletingSchedule}
          onCancel={() => setopenALertDialog(false)}
          onConfirm={handleConfirmDelete}
          title={`Delete Schedule Extraction`}
          description={`Are you sure you want to delete this schedule extraction?`}
        />

    </Box>
  );
}
